$(function () {
    // slick
    $('.slick-image-box').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        fade: true,
        dots: true,
        easing: "swing",
        speed: 1000
    });

    // メニュー開閉
    var menulink = $(".lp-menu-bar-link");
    var menucontent = $(".lp-menu");
    var menuhr1 = $(".lp-hr-1");
    var menuhr3 = $(".lp-hr-3");
    var productlink = $(".lp-menu-product");
    var producttablelink = $(".lp-menu-table");
    $(menulink).on('click',function(e){ 
        e.preventDefault();
        $(menucontent).slideToggle();
        $(menuhr1).toggleClass("opened");
        $(menuhr3).toggleClass("opened");
    });
    $(productlink).on('click',function(e){ 
        $(menucontent).slideUp();
        $(menuhr1).removeClass("opened");
        $(menuhr3).removeClass("opened");
        var speed = 800;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });
    $(producttablelink).on('click',function(e){ 
        $(menucontent).slideUp();
        $(menuhr1).removeClass("opened");
        $(menuhr3).removeClass("opened");
        var speed = 800;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });

    // スクロールバーFadeout
    var fadeoutScrollBar = {
        "display" : "none",
        "transition" : "all 500ms"
    }
    var $scrollBar = $('.scroll-bar-jquery');
    $(window).scroll(function() {
        // ページのスクロール量を取得
        var scroll = $(this).scrollTop();
        // スクロールバー Fadeout
        if (scroll >= 5) {
            $scrollBar.css(fadeoutScrollBar);
        }
    });

    // アコーディオン
    $('.lp-product-parts-box').each(function(index, element) {
        var target = $(element).find(".accordion-opened");
        var showbutton = $(element).find(".view-more-button");
        var showbuttonarrow = $(element).find(".view-more-button .view-more-arrow");
        var hidebutton = $(element).find(".accordion-close-button");
        $(showbutton).on('click',function(e){ 
            e.preventDefault();
            $(target).slideToggle();
            $(showbuttonarrow).toggleClass("opened");
        });
        $(hidebutton).on('click',function(e){ 
            e.preventDefault();
            $(target).slideUp();
            $(showbuttonarrow).removeClass("opened");
        });
    })
})